import script from "./ProductionProjectDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionProjectDetailView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__